export default __webpack_public_path__ + "static/accelerate-ai-dark-b6a9052118f49a9c0a316e6ed70ffc8c.png";